import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";

type Response = components["schemas"]["AllHotDataModel"];

const REQUEST_TYPE: keyof typeof apiConfig = 'get home all whats hot data';

const DEFAULT_DATA: Response = {
    data: [],
};

async function getHomeAllWhatsHotData(): Promise<Response> {
    try {
        return await http.get(REQUEST_TYPE) as Response;

    } catch (error) {
        console.error('Fetch error:', REQUEST_TYPE, error);
        return DEFAULT_DATA;
    }
}

export function useHomeAllWhatsHotData() {
    return useData(DEFAULT_DATA, getHomeAllWhatsHotData);
}